import { cn } from "@/lib/utils";
import type { CSSProperties } from "react";

interface Props {
  /** 0..1 */
  value: number;
  /** Any CSS color (or var). Defaults to accent gold. */
  color?: string;
  size?: "sm" | "md";
  className?: string;
}

/**
 * Melli-style status bar: flat fill + thin top highlight + sharp edges.
 * Inspired by the Melli statusbar texture popularized in ElvUI / Tukui.
 */
export function MelliBar({ value, color, size = "md", className }: Props) {
  const pct = Math.max(0, Math.min(1, value)) * 100;
  return (
    <div
      className={cn("melli-track", size === "sm" && "melli-track-sm", className)}
    >
      <div
        className="melli-fill"
        style={{
          width: `${pct}%`,
          ["--melli-color" as keyof CSSProperties]: color ?? "var(--color-accent)",
        } as CSSProperties}
      />
    </div>
  );
}
